/**
 * Formatea una fecha en formato ISO a un formato legible
 * @param isoDate Fecha en formato ISO o objeto Date
 * @param options Opciones de formato
 * @returns Fecha formateada
 */
export const formatDate = (isoDate: string | Date, options?: Intl.DateTimeFormatOptions): string => {
  if (!isoDate) return '-';
  
  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };
  
  try {
    const date = isoDate instanceof Date ? isoDate : new Date(isoDate);
    if (isNaN(date.getTime())) return '-';
    
    return date.toLocaleDateString('es-ES', options || defaultOptions);
  } catch (error) {
    console.error('Error al formatear fecha:', error);
    return typeof isoDate === 'string' ? isoDate : '-';
  }
};

/**
 * Formatea un valor numérico a formato de moneda
 * @param value Valor a formatear
 * @param currency Símbolo de moneda
 * @returns Valor formateado
 */
export const formatCurrency = (value: string | number, currency = '$'): string => {
  if (value === null || value === undefined) return '-';
  
  try {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    return `${currency}${numValue.toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  } catch (error) {
    console.error('Error al formatear moneda:', error);
    return `${currency}${value}`;
  }
}; 